

























































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import FormProvider from '@shared/components/forms/form-provider.vue';
import moment from 'moment';
import { Activity } from '@activities/interfaces/activity';
import ActivityFormV2 from '@activities/components/forms/activity-form-v2/activity-form-v2.vue';
import ActivitySessionContainer from '@activities/components/containers/activity-session-container/activity-session-container.vue';
import ActivitySessionAttendeeTable from '@activities/components/tables/activity-session-attendee-table/activity-session-attendee-table.vue';
import { v4 as uuidv4 } from 'uuid';
import ActivityFormulaForm from '@activities/components/forms/activity-formula-form/activity-formula-form.vue';
import { ActivityGroup } from '@activities/interfaces/activity-group';
import { setProp } from '@shared/helpers/operators';
import MessageList from '@communications/components/lists/message-list.vue';
import ActivityTrainingForm from '@activities/components/forms/activity-training-form/activity-training-form.vue';
import ActivityCompetitionForm from '@activities/components/forms/activity-competition-form/activity-competition-form.vue';
import ActivitySessionGameTable from '@activities/components/tables/activity-session-game-table/activity-session-game-table.vue';

@Component({
  name: 'bpc-activity-single',
  components: {
    ActivitySessionAttendeeTable,
    'bpc-content-wrapper': ContentWrapper,
    'bpc-activity-form-v2': ActivityFormV2,
    'bpc-activity-training-form': ActivityTrainingForm,
    'bpc-activity-competition-form': ActivityCompetitionForm,
    'bpc-activity-session-container': ActivitySessionContainer,
    'bpc-activity-session-attendee-table': ActivitySessionAttendeeTable,
    'bpc-activity-formula-form': ActivityFormulaForm,
    'bpc-message-list': MessageList,
    'bpc-activity-session-game-table': ActivitySessionGameTable,
  },
})
export default class ActivitySingle extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
    trainingContainer: InstanceType<typeof ActivitySessionContainer> & {
      refreshSessionsTable(): void;
    };
  };
  // PROPS
  @Prop(Object) readonly initialData: Activity;
  @Prop(Number) readonly modelId: number;
  @Prop({ type: String, default: '' }) readonly componentId: string;
  @Prop({ type: String, default: 'page' }) readonly displayMode: string;
  @Prop({ type: String, default: 'edition' }) readonly actionMode: string;
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: Boolean, default: false }) readonly noFetchData: boolean;

  // DATA
  formModel: Activity = null;
  dataLoaded: boolean = false;
  timestamp = moment().unix();
  selectedTab: number = 0;
  // data to manage activity form
  activityFormIsEditable = true;
  addingMembersToTraining: boolean = false;
  addedMembersToTraining: boolean = false;
  errorAddingTeamMembersToTraining: boolean = false;
  membersToAdd: number = 0;
  membersAdded: number = 0;
  showAttendeeExtendedFilters: boolean = false;

  // COMPUTED
  get activityType(): string {
    return this.formModel?.activity_type;
  }

  get activityId(): number {
    return Number(this.formModel?.id || this.modelId || this.$route.params?.id || null);
  }

  get activityGroup(): ActivityGroup {
    return this.formModel?.activity_groups[0];
  }

  set activityGroup(data) {
    this.formModel.activity_groups[0] = data;
  }

  get activityGroupId(): number {
    return this.activityGroup?.id;
  }

  get activityGroupName(): string {
    return this.activityGroup?.name;
  }

  get filterByActivityId(): object[] {
    return [{ filterField: 'activity_id', modelField: null, value: this.activityId }];
  }

  get activityFormButtonsPortalTarget(): string {
    return `activity-form-buttons-${this.timestamp}`;
  }

  get messageTabActionsPortalTarget() {
    return `message-tab-actions-${this.timestamp}`;
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  get tabSessionTitle(): string {
    return this.activityType === 'competition'
      ? (this.$t('global.tabs.calendar') as string)
      : (this.$t('global.tabs.activity_sessions') as string);
  }

  // LIFECYCLE
  // created(){}
  beforeMount() {
    this.listenToWebsocketAddTeamMembersToTrainingChannel();
  }

  mounted() {
    this.initModel();
    this.isActivityFormEditable();
  }
  // updated(){}
  destroyed() {
    this.leaveWebsocketAddTeamMembersToTrainingChannel();
  }

  // METHODS

  async initModel() {
    this.dataLoaded = false;

    if (this.initialData) {
      this.formModel = this.initialData;
    }
    if (!this.noFetchData) {
      await this.fetchData();
    }
    this.dataLoaded = true;
  }

  async fetchData() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('bpc-activity');
    const path = `${basePath}/${this.modelId}`;
    const res = await this.$bpcApi.get(path).toPromise();
    this.formModel = res.data;
  }

  get sessionFormConfigName() {
    switch (this.activityType) {
      case 'competition':
        return this.tenantType === 'club' ? 'create-from-management-for-clubs' : null;
      case 'training':
        return this.tenantType === 'club' ? 'create-from-management-for-clubs' : null;
      default:
        return this.tenantType === 'club' ? 'create-from-management-for-clubs' : null;
    }
  }

  get sessionEditFormConfigName() {
    switch (this.activityType) {
      case 'competition':
        return this.tenantType === 'club' ? 'edit-competition-for-clubs' : null;
      case 'training':
        return this.tenantType === 'club' ? 'edit-from-management-for-clubs' : null;
      default:
        return this.tenantType === 'club' ? 'create-from-management-for-clubs' : null;
    }
  }

  get attendeeFormConfigName() {
    switch (this.activityType) {
      case 'competition':
        return this.tenantType === 'club' ? 'default-for-clubs' : null;
      case 'training':
        return this.tenantType === 'club' ? 'default-for-clubs' : null;
      default:
        return this.tenantType === 'club' ? 'default-for-clubs' : null;
    }
  }

  get attendeeEditFormConfigName() {
    switch (this.activityType) {
      case 'competition':
        return this.tenantType === 'club' ? 'edit-competition-attendee-for-clubs' : null;
      case 'training':
        return this.tenantType === 'club' ? 'edit-training-attendee-for-clubs' : null;
      default:
        return this.tenantType === 'club' ? 'edit-for-clubs' : null;
    }
  }

  isActivityFormEditable() {
    if (
      !this.$authorizationService.hasPermission('manage_activity_sessions') &&
      this.$authorizationService.hasPermission('manage_own_activity_sessions')
    ) {
      this.activityFormIsEditable = false;
    }
  }

  onSavedTraining($event) {
    setProp(this.formModel, 'activity_groups', $event.data.activity_groups);
  }

  onSavedCompetition($event) {
    setProp(this.formModel, 'activity_groups', $event.data.activity_groups);
  }

  onClickRefreshTrainingTableAfterAddingMembers() {
    this.$refs.trainingContainer.refreshSessionsTable();
  }

  listenToWebsocketAddTeamMembersToTrainingChannel() {
    this.$bpcEcho
      .listenAddTeamMembersToTrainingChannel()
      .listen('.BPC\\Activities\\Events\\AddTeamMembersToTrainingStarted', data => {
        this.membersToAdd = data.data?.totalToAdd;
        this.addingMembersToTraining = true;
      })
      .listen('.BPC\\Activities\\Events\\TeamMemberAddedToTraining', data => {
        this.membersToAdd = data.data?.totalToAdd;
        this.membersAdded = data.data?.totalAdded;
        this.addingMembersToTraining = !this.addedMembersToTraining;
      })
      .listen('.BPC\\Activities\\Events\\AllTeamMembersAddedToTraining', data => {
        this.addingMembersToTraining = false;
        this.addedMembersToTraining = true;
      })
      .listen('.BPC\\Activities\\Events\\ErrorAddingTeamMembersToTraining', data => {
        this.addingMembersToTraining = false;
        this.addedMembersToTraining = false;
        this.errorAddingTeamMembersToTraining = true;
      });
  }

  leaveWebsocketAddTeamMembersToTrainingChannel() {
    this.$bpcEcho.leaveAddTeamMembersToTrainingChannel();
  }
  // WATCHERS
}
